module.exports = __webpack_public_path__ + "static/media/ios.8dd88d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ios.png
// module id = 175
// module chunks = 0